import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import AppleLoginButton from '../../../components/Auth/AppleLogin/AppleLogin';
import Spinner from '../../../components/UI/Spinner/Spinner';
import config from '../../../constants/config';

class AppleLoginContainer extends Component {
  state = { showSpinner: true };

  componentDidMount() {
    if (this.props.getConfig.status === 'success') {
      this.setState({ showSpinner: false });
    } else {
      this.setState({ showSpinner: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.getConfig.status === 'success' &&
      prevProps.getConfig.status !== 'success'
    ) {
      this.setState({ showSpinner: false });
    }
  }

  render() {
    let content = null;
    // console.log('AppleLoginContainer RENDER::::', this.props);
    if (config.TYPE !== 'adult' && this.state.showSpinner) {
      content = (
        <Spinner
          customSpinnerStyle={{ margin: '0 auto', marginBottom: '1rem' }}
          size='Tiny'
        />
      );
    } else if (
      config.TYPE !== 'adult' &&
      this.props.getConfig.response &&
      this.props.getConfig.response.ios_auth &&
      this.props.getConfig.response.ios_auth.query_params &&
      this.props.getConfig.response.ios_auth.query_params.response_type &&
      this.props.getConfig.response.ios_auth.query_params.response_mode &&
      this.props.getConfig.response.ios_auth.query_params.client_id &&
      this.props.getConfig.response.ios_auth.query_params.redirect_uri &&
      this.props.getConfig.response.ios_auth.query_params.scope
    ) {
      content = (
        <AppleLoginButton
          {...this.state}
          style={this.props.style}
          queryParams={this.props.getConfig.response.ios_auth.query_params}
        >
          {this.props.children}
        </AppleLoginButton>
      );
    }

    return <Fragment>{content}</Fragment>;
  }
}

function mapStateToProps(state) {
  return {
    getConfig: state.getConfig,
  };
}

export default connect(mapStateToProps)(AppleLoginContainer);
